<template>
    <el-dialog title="添加已有账号" :visible="isShow" :before-close="handleClose">
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="UID" prop="user_id" :label-width="formLabelWidth">
                <el-input v-model="form.user_id" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="username" :label-width="formLabelWidth">
                <el-input v-model="form.username" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="真实姓名" prop="real_name" :label-width="formLabelWidth">
                <el-input v-model="form.real_name" autocomplete="off"></el-input>
            </el-form-item>
<!--            <el-form-item label="身份" prop="identity" :label-width="formLabelWidth">-->
<!--                <el-select v-model="form.identity" style="width:100%" placeholder="请选择账号组">-->
<!--                    <el-option-->
<!--                            v-for="(identity, key) in identities "-->
<!--                            :key="key"-->
<!--                            :label="identity"-->
<!--                            :value="key"-->
<!--                    >-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="设为管理员" :label-width="formLabelWidth">
                <el-switch
                        v-model="form.is_admin"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>

           <!-- <el-form-item label="设为公用账号" :label-width="formLabelWidth">
                <el-switch
                        v-model="form.is_common"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-value="1"
                        inactive-value="0">
                </el-switch>
            </el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import AccountService from "~/services/CustomerAccounts";

    export default {
        name: "AddExist",
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            display: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            display: function (value, origin) {
                this.isShow = value;
            }
        },

        data() {
            return {
                loading: false,
                isShow: false,
                formLabelWidth: '120px',
                form: {},
                identities: {},
                rules: {
                    customer_id: [
                        {required: true, message: "所属客户不允许为空", trigger: "blur"},
                    ],
                    identity: [
                        {required: true, message: "必须选择一个身份", trigger: "blur"}
                    ],
                    real_name: [
                        {required: true, message: "真实姓名不允许为空", trigger: "blur"}
                    ]
                }

            };
        },

        created: function () {
            this.isShow = this.display;
            this.form = this.getModel();
            this.identities = AccountService.getIndentify();
        },

        methods: {

            getModel() {
                return {
                    "user_id": "",
                    "username": "",
                    "customer_id": this.customerId,
                    "real_name": "",
                    "identity": "1",
                    "group_id": "",
                    "is_admin": 0,
                    "is_common": 0
                }
            },

            close(status = false) {
                this.isShow = false;
                this.$refs["form"].resetFields();
                this.$emit("callback", status);
            },

            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？", "温馨提示", {type: "warning"}).then(ok => {
                    this.close();
                }).catch(cancel => {
                    return false;
                });
            },

            submitForm() {
                this.$refs["form"].validate(valid => {
                    if (this.form.user_id < 1 && this.form.username == '') {
                        this.$message.error("UID 或者 用户名 必须填写其中一个");
                        return;
                    }
                    this.loading = true;
                    if (valid) {
                        AccountService.addExist(this.form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "添加成功!",
                                    type: "success",
                                    showClose: true,
                                });
                                this.close(true);
                            }
                            this.loading = false;
                        }).catch(error => {
                            this.loading = false;
                            console.error(error);
                        })
                    }
                })
            },

        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/dialog/AddExist.vue